import { render, staticRenderFns } from "./globalSettings.vue?vue&type=template&id=4263b5e8&scoped=true"
import script from "./globalSettings.vue?vue&type=script&lang=js"
export * from "./globalSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4263b5e8",
  null
  
)

export default component.exports